/**
 * Add or remove sticky header class on scroll
 */
$(function() {
    var win = $(window);
    var header = $('.page-header');
    var side = header.find('.side');

    // Add or remove the toggle function from the scroll event depending on the
    // screen width. The header is never sticky at smaller screen sizes, so
    // there is no need to use the toggle function unless the screen is wide
    // enough for it to have an effect.
    //
    // We also remove the fixed and short classes from the header element at
    // small screen sizes.
    var init = function() {
        if (win.width() < 1280) {
            win.off('scroll', toggle);
            header.removeClass('fixed short');

            return;
        }

        win.on('scroll', toggle);
        toggle();
    };

    // Add the fixed class to the header when the main part of the header hits
    // the top of the screen. Add the short class to the header when the page
    // has been scrolled down enough that it won't create a blank white space
    // underneath the header.
    var toggle = function() {
        header.toggleClass('fixed', win.scrollTop() > side.outerHeight());
        header.toggleClass('short', win.scrollTop() > header.outerHeight());
    };

    // Make it all work on page load and when the window has been resized.
    win.on('load resizeDone', init);
});
